export const readEmpty = async (sales, filterThis, startDate, endDate) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listSalesMeeting?sales=${sales}&filterThis=${filterThis}&startDate=${startDate}&endDate=${endDate}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}